import { Dispatch } from "react";
import { Action, ActionType, PlanType } from "../../../@types";
import { getCounty } from "../../../api";
import URI from "urijs";
import { parseSearchParams } from "../../../helpers";

type URLParseAction = (dispatch: Dispatch<Action>, url: URI) => void;

export const setPlanTypeFromURL: URLParseAction = (dispatch, url) => {
  const { plan_type } = parseSearchParams(url.search(true));

  if (plan_type) {
    dispatch({
      type: ActionType.UPDATE_PLAN_TYPE,
      payload: plan_type.toUpperCase() as PlanType,
    });
  }
};

export const setFipsFromURL: URLParseAction = (dispatch, url) => {
  const { fips } = url.search(true);

  if (fips) {
    dispatch({
      type: ActionType.UPDATE_FIPS,
      payload: fips,
    });
  } else {
    throw new Error("Error retrieving fips value from URL");
  }
};

export const setZipcodeFromURL = (
  dispatch: Dispatch<Action>,
  url: URI
): void => {
  const { zipcode } = parseSearchParams(url.search(true));

  if (zipcode && /^\d{5}$/.test(zipcode)) {
    dispatch({
      type: ActionType.UPDATE_ZIPCODE,
      payload: zipcode,
    });
  } else {
    throw new Error("Error retrieving zipcode from URL");
  }
};

export const resolveCountyFromURL = (
  dispatch: Dispatch<Action>,
  url: URI
): void => {
  const { fips } = parseSearchParams(url.search(true));

  if (fips) {
    getCounty(fips).then(
      county => {
        dispatch({
          type: ActionType.UPDATE_COUNTY,
          payload: county,
        });

        dispatch({ type: ActionType.UPDATE_FIPS, payload: county?.fips });
      },
      () => {
        throw new Error(
          `Error resolving a county for the given fips value: ${fips}`
        );
      }
    );
  } else {
    throw new Error("Error fips value required to resolve a County");
  }
};
